
import { Component, OnInit, OnDestroy, ViewChild, ChangeDetectorRef, ElementRef, AfterViewInit } from '@angular/core';
import { ChartService } from '../../services/chart.service';
import * as moment from 'moment';
import { Observable } from 'rxjs';
import { shareReplay } from 'rxjs/operators';
import { ViewportRuler } from '@angular/cdk/overlay';

import {
  CdkDrag,
  CdkDropList, CdkDropListGroup, CdkDragMove,
  moveItemInArray,
} from '@angular/cdk/drag-drop';
import { TranslateService } from '@ngx-translate/core';
import { NavigationEnd, Router } from '@angular/router';


@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit, OnDestroy, AfterViewInit {

  cardData: Array<{
    deviceId: String,
    notificationsObs: Observable<any>,
    connectNotificationsObs: Observable<any>,
    synchronisationObs: Observable<any>,
    currentTempObs: Observable<any>,
    currentHumObs: Observable<any>,
    maxTempObs: Observable<any>,
    minTempObs: Observable<any>,
    maxHumObs: Observable<any>,
    minHumObs: Observable<any>,
    doorObs: Observable<any>,
    deviceNameObs: Observable<any>,
    calibHumTempObs: Observable<any>,
  }> = [];

  doorOpen = false;
  loaded = false;
  naCard: Array<any> = [];

  // get user id to hide door label of 2as clients.
  userId = '';

  // ==== All the drag grid staffs definitions goes here ==== */
  @ViewChild(CdkDropListGroup) listGroup: CdkDropListGroup<CdkDropList>;
  @ViewChild(CdkDropList) placeholder: CdkDropList;
  public target: CdkDropList;
  public targetIndex: number;
  public source: CdkDropList;
  public sourceIndex: number;
  public dragIndex: number;
  public activeContainer;
  public orderedDevices: any;
  // ****  All the drag grid staffs definitions goes above ****/

  constructor(
    private service: ChartService,
    private viewPortRuler: ViewportRuler,
    private changeDetector: ChangeDetectorRef,
    private elementRef: ElementRef,
    public translate: TranslateService,
    private router: Router) {


    // ******** drag grid ****/
    this.target = null;
    this.source = null;
    // **********************/

    translate.addLangs(['en', 'fr']);
    translate.setDefaultLang('en');
    // get the language from cookie if it exists
    if (!this.service.checkCookie('language')) {
      const browserLang = translate.getBrowserLang();
      translate.use(browserLang.match(/en|fr/) ? browserLang : 'en');
    } else {
      translate.use(this.service.getCookie('language'));
    }
  }

  // Added for the drop staffs
  ngAfterViewInit() {
    // Hide the placeholder
    if (this.placeholder != null) {
      const phElement = this.placeholder.element.nativeElement;
      phElement.style.display = 'none';
      phElement.parentElement.removeChild(phElement);
    }
    // Style the background
    // this.addBackground();
    setTimeout(() => {
      this.changeDetector.detectChanges();
    }, 1000);
  }

  ngOnInit() {
    this.userId = this.service.getUserId();
    this.getAllDeviceId();
  }

  getAllDeviceId() {
    this.service.getAllKey().then(keyArray => {
      this.loaded = false;
      for (const key of keyArray) {
        if (!(key === 'ESP2635206COPY'
          || key === 'ESP47A477')) { // To hide 'Archive' and unused devices from 2AS
          this.cardData.push({
            deviceId: key,
            notificationsObs: this.service.getNotificationsNumber(key),
            connectNotificationsObs: this.service.getNotificationsConnectNumber(key),
            synchronisationObs: this.service.getSynchronisation(key),
            currentTempObs: this.service.getCurrentTemp(key),
            currentHumObs: this.service.getCurrentHum(key),
            maxTempObs: this.service.getMaxTemp(key),
            minTempObs: this.service.getMinTemp(key),
            maxHumObs: this.service.getMaxHum(key),
            minHumObs: this.service.getMinHum(key),
            doorObs: this.service.getDoorState(key),
            deviceNameObs: this.service.getDeviceName(key),
            calibHumTempObs: this.service.getCalibTempHumObservable(key)
          });
        }
      }

      /** 2AS
       * New as 02/04/2021 add a copy of device SF02 - ESP2635206 - COLLE
       * we will make it's key "ESP2635206COPY" and name it "SF02 Copie"
       * just to test "Moyenne horaires"
      */
      if (this.userId === '2wK3hBuWM5h3oP7BKlaufH3Dp042' || this.userId === 'gABiZosJ5GUUqNtL7kE3B1kpEgJ3') {
        this.cardData.push({
          deviceId: 'ESP2635206COPY',
          notificationsObs: this.service.getNotificationsNumber('ESP2635206'),
          connectNotificationsObs: this.service.getNotificationsConnectNumber('ESP2635206'),
          synchronisationObs: this.service.getSynchronisation('ESP2635206'),
          currentTempObs: this.service.getCurrentTemp('ESP2635206'),
          currentHumObs: this.service.getCurrentHum('ESP2635206'),
          maxTempObs: this.service.getMaxTemp('ESP2635206'),
          minTempObs: this.service.getMinTemp('ESP2635206'),
          maxHumObs: this.service.getMaxHum('ESP2635206'),
          minHumObs: this.service.getMinHum('ESP2635206'),
          doorObs: this.service.getDoorState('ESP2635206'),
          deviceNameObs: this.getCustomDeviceNameObservabele('SF02 Copie - pour tester les moyennes horaires !'),
          calibHumTempObs: this.service.getCalibTempHumObservable('ESP2635206')
        });
      }


      for (const data of this.cardData) {
        data.deviceNameObs.pipe(
          shareReplay(1) // the solution that I found to dispaly device name correctly.
        );
      }
      for (let i = 0; i < (18 - this.cardData.length); i++) {
        this.naCard.push(i);
      }

      this.loaded = true;
      // We use changeDetector because: https://stackoverflow.com/questions/39366981/viewchild-in-ngif.
      this.changeDetector.detectChanges();
      // Hide the placeholder
      const phElement = this.placeholder.element.nativeElement;
      phElement.style.display = 'none';
      phElement.parentElement.removeChild(phElement);
    });

  }





  msToTime(dateInMillis): string {
    moment.locale(this.translate.currentLang);
    const m = moment(dateInMillis);
    return m.fromNow();
  }


  /** Logout */
  deconnect() {
    this.service.signOut();
  }


  ngOnDestroy() {
    // moment.locale('en'); // to avoid invalid date errors in dashboard chartjs.
    if (this.orderedDevices != null) {
      this.service.saveOrder(this.orderedDevices); // Save devices order to database.
    }
  }






  // ************************* Methods of drop drag staffs ************************************
  dropGrid() {
    if (!this.target) {
      return;
    }
    const phElement = this.placeholder.element.nativeElement;
    const parent = phElement.parentElement;
    phElement.style.display = 'none';
    parent.removeChild(phElement);
    parent.appendChild(phElement);
    parent.insertBefore(this.source.element.nativeElement, parent.children[this.sourceIndex]);

    this.target = null;
    this.source = null;

    if (this.sourceIndex !== this.targetIndex) {
      moveItemInArray(this.cardData, this.sourceIndex, this.targetIndex);
      // Create ordKey object containing the devices order choosen by the user.
      const ordKey = {};
      this.cardData.forEach((data, index) => {
        ordKey['' + index] = data.deviceId;
      });
      this.orderedDevices = ordKey;
    }
  }





  dragMoved(e: CdkDragMove) {
    const point = this.getPointerPositionOnPage(e.event);
    this.listGroup._items.forEach(dropList => {
      if (__isInsideDropListClientRect(dropList, point.x, point.y)) {
        this.activeContainer = dropList;
        return;
      }
    });
  }




  enterPredicate = (drag: CdkDrag, drop: CdkDropList) => {
    if (drop === this.placeholder) {
      return true;
    }
    if (drop !== this.activeContainer) {
      return false;
    }

    const phElement = this.placeholder.element.nativeElement;
    const sourceElement = drag.dropContainer.element.nativeElement;
    const dropElement = drop.element.nativeElement;

    const dragIndex = __indexOf(dropElement.parentElement.children, (this.source ? phElement : sourceElement));
    const dropIndex = __indexOf(dropElement.parentElement.children, dropElement);

    if (!this.source) {
      this.sourceIndex = dragIndex;
      this.source = drag.dropContainer;

      phElement.style.width = sourceElement.clientWidth + 'px';
      phElement.style.height = sourceElement.clientHeight + 'px';

      sourceElement.parentElement.removeChild(sourceElement);
    }

    this.targetIndex = dropIndex;
    this.target = drop;

    phElement.style.display = '';
    dropElement.parentElement.insertBefore(phElement, (dragIndex < dropIndex) ? dropElement.nextSibling : dropElement);
    this.placeholder._dropListRef.enter(drag._dragRef, drag.element.nativeElement.offsetLeft, drag.element.nativeElement.offsetTop);

    return false;
  }

  /** Determines the point of the page that was touched by the user. */
  getPointerPositionOnPage(event: MouseEvent | TouchEvent) {
    // `touches` will be empty for start/end events so we have to fall back to `changedTouches`.
    const point = __isTouchEvent(event) ? (event.touches[0] || event.changedTouches[0]) : event;
    const scrollPosition = this.viewPortRuler.getViewportScrollPosition();

    return {
      x: point.pageX - scrollPosition.left,
      y: point.pageY - scrollPosition.top
    };
  }

  // ************************* END methods of drop drag staffs ************************************

  // 2AS Get custom device name in observable (new as 02/04/2021 moyenne temperature 2AS)
  getCustomDeviceNameObservabele(deviceName: string): Observable<string> {
    const observable: Observable<string> = new Observable((observer => {
      observer.next(deviceName);
      observer.complete();
      return () => console.log('');
    }));
    return observable;
  }



}





function __indexOf(collection, node) {
  return Array.prototype.indexOf.call(collection, node);
}

/** Determines whether an event is a touch event. */
function __isTouchEvent(event: MouseEvent | TouchEvent): event is TouchEvent {
  return event.type.startsWith('touch');
}

function __isInsideDropListClientRect(dropList: CdkDropList, x: number, y: number) {
  const { top, bottom, left, right } = dropList.element.nativeElement.getBoundingClientRect();
  return y >= top && y <= bottom && x >= left && x <= right;
}
